<template>
  <div class="gwbtns">
    <slot name="before"></slot>
    <div
      v-for="(item, idx) in options"
      :ref="`item_${idx}`"
      :key="item[idKey]"
      :data-idx="idx"
      class="gw_btn gwbtns_btn"
      :class="[
        {
          gw_btn_active:
            value !== undefined
              ? value === (item[idKey] || item)
              : values.includes(item[idKey] || item),
        },
        {
          gw_btn_disabled: disabled ? disabled.includes(item[idKey] || item) : false,
        },
        {
          gw_btn_hovered: hoverIdx === idx,
        },
        {
          gw_btn_nohover: hoverIdx !== idx,
        },
        btnClass || '',
      ]"
      @click="e => $emit('click', e, item)"
      @mouseenter="
        e => {
          setHoverIdx(idx)
          $emit('mouseenter', item)
        }
      "
      @mouseleave="$emit('mouseleave', item)"
      @mousedown="$emit('mousedown', item)"
    >
      <slot
        :item="item"
        :value="value"
      >
        {{ value }}
        {{ item }}
      </slot>
    </div>
    <slot name="after"></slot>
  </div>
</template>

<script>
import { nextTick } from 'vue'

export default {
  name: 'GwBtns2',
  props: {
    options: Array,
    disabled: Array,
    idKey: { default: 'id' },
    value: [String, Number, Object],
    values: { default: () => [] },
    btnClass: String,
    arrowControls: Boolean,
  },
  emits: ['click', 'mouseenter', 'mouseleave', 'mousedown', 'mounted'],
  data() {
    return {
      mousedown: false,
      hoverIdx: 0,
    }
  },
  mounted() {
    nextTick(() => {
      this.$emit('mounted')
      if (!this.arrowControls) return
      this.setHoverIdx(0)
      window.addEventListener('keydown', this.handleKeyboard)
    })
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleKeyboard)
  },
  methods: {
    setHoverIdx(idx) {
      if (!this.arrowControls) return
      idx = idx < 0 ? this.options.length - 1 : idx === this.options.length ? 0 : idx
      this.hoverIdx = idx
    },
    scrollToView() {
      const item = this.$refs[`item_${this.hoverIdx}`][0]
      const observer = new IntersectionObserver(
        entries => {
          if (entries[0].intersectionRatio < 0.5) {
            item.scrollIntoView({
              behavior: 'smooth',
              block: 'end',
              inline: 'end',
            })
          }
          observer.unobserve(item)
        },
        {
          rootMargin: '0px',
          threshold: 1,
        },
      )
      observer.observe(item)
    },
    handleKeyboard(e) {
      const actions = {
        ArrowUp: () => {
          this.setHoverIdx(this.hoverIdx - 1)
        },
        ArrowDown: () => {
          this.setHoverIdx(this.hoverIdx + 1)
        },
        Enter: () => {
          this.$emit('click', {}, this.options[this.hoverIdx])
        },
      }
      if (actions[e.key]) {
        e.preventDefault()
        actions[e.key]()
        if (e.key !== 'Enter') this.scrollToView()
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.gwbtns {
  --gwbtn-flex: unset;
  --gwbtn-flex-shrink: 0;
  --gwbtn-size: 0.875rem;
  --gwbtn-weight: 500;
  --gwbtn-padding: 0 0.25rem;
  --gwbtn-clr-back: var(--clr-black-1-3);
  --gwbtn-clr-active-white: var(--clr-black-2);
  // --gwbtn-clr-active-white: var(--clr-black-3);
  // --gwbtn-clr-active-white: rgba(255, 255, 255, 0.15);
  --gwbtn-clr-hover-white: rgba(255, 255, 255, 0.25);
  --gwbtn-clr-disabled-white: rgba(255, 255, 255, 0);
  // --gwbtn-clr-hover-white: rgba(255, 255, 255, 0.2);

  --gwbtn-clr: var(--clr-grey-2);
  --gwbtn-clr-hover: var(--clr-white-0);
  --gwbtn-clr-active: var(--clr-white-0);
  --gwbtn-padding: 0 1rem;
  --gwbtn-height: 1.5rem;
  // --gwbtn-width: unset;
  --gwbtn-justify-content: center;

  --gwbtn-pointer-events: all;
  --gwbtn-pointer-events-disabled: unset;

  --gwbtn-clr-disabled: currentColor;

  --gwbtns-gap: 2px;
  --gwbtns-direction: row;
  --gwbtns-wrap: nowrap;
  --gwbtns-padding: 0;
  display: flex;
  flex-direction: var(--gwbtns-direction);
  flex-wrap: var(--gwbtns-wrap);
  padding: var(--gwbtns-padding);
  gap: var(--gwbtns-gap);
  // &_horizontal-grey-nora {

  // }
  &_vertical_primary {
    --gwbtns-direction: column;
    --gwbtns-padding: 0.5rem 0.25rem;

    --gwbtn-clr-back: transparent;
    // --gwbtn-clr-active-white: var(--clr-black-2);
    --gwbtn-clr-hover-white: rgba(255, 255, 255, 0.125);
    --gwbtn-justify-content: flex-start;

    --gwbtn-clr: var(--clr-white-0);
    --gwbtn-clr-hover: var(--clr-primary);
    --gwbtn-clr-active: var(--clr-primary);

    --gwbtn-padding: 0 0.5rem;
    --gwbtn-height: 1.75rem;
  }
  &_vertical_grey {
    --gwbtns-direction: column;
    --gwbtns-padding: 0.5rem 0.25rem;

    --gwbtn-clr-back: transparent;
    --gwbtn-clr-back: var(--clr-black-1-3);
    // --gwbtn-clr-active-white: var(--clr-black-2);
    --gwbtn-clr-hover-white: rgba(255, 255, 255, 0.125);
    --gwbtn-justify-content: flex-start;

    --gwbtn-clr: var(--clr-grey-2);
    --gwbtn-clr-hover: var(--clr-white-0);
    --gwbtn-clr-active: var(--clr-white-0);

    --gwbtn-padding: 0 0.5rem;
    --gwbtn-height: 1.75rem;
  }
  &_vertical_white {
    --gwbtns-direction: column;
    --gwbtns-padding: 0.5rem 0.25rem;

    --gwbtn-clr-back: transparent;
    // --gwbtn-clr-active-white: var(--clr-black-2);
    --gwbtn-clr-hover-white: rgba(255, 255, 255, 0.125);
    --gwbtn-justify-content: flex-start;

    --gwbtn-clr: var(--clr-white-0);
    --gwbtn-clr-hover: var(--clr-white-0);
    --gwbtn-clr-active: var(--clr-white-0);

    --gwbtn-padding: 0 0.5rem;
    --gwbtn-height: 1.75rem;
  }
  // &_horizontal{

  // }
  &_btn {
    white-space: nowrap;

    --clr-back: var(--gwbtn-clr-back);
    font-size: var(--gwbtn-size);
    font-weight: var(--gwbtn-weight);
    padding: var(--gwbtn-padding);
    flex: var(--gwbtn-flex);
    flex-shrink: var(--gwbtn-flex-shrink);
    justify-content: var(--gwbtn-justify-content);
    // width: var(--gwbtn-width);

    --clr-active-white: var(--gwbtn-clr-active-white);
    --clr-hover-white: var(--gwbtn-clr-hover-white);
    --clr-disabled-white: var(--gwbtn-clr-disabled-white);
    --clr: var(--gwbtn-clr);
    --clr-hover: var(--gwbtn-clr-hover);
    --clr-active: var(--gwbtn-clr-active);
    --clr-disabled: var(--gwbtn-clr-disabled);
    --padding: var(--gwbtn-padding);
    --height: var(--gwbtn-height);

    --pointer-events: var(--gwbtn-pointer-events);
    --pointer-events-disabled: var(--gwbtn-pointer-events-disabled);
  }
}
</style>
